{
  "iconStyle": {
    "alignment": "Alignement",
    "screen": "Écran aligné",
    "north": "Aligné au nord"
  },
  "mapObjectSelectionHelpers": {
    "layerNotVisible": {
      "message": "L'objet cartographique sélectionné se trouve sur une couche visuellement masquée",
      "cta": "Activer/désactiver la visibilité"
    },
    "objectOnDifferentLevel": {
      "message": "L'objet cartographique sélectionné se trouve à un niveau différent",
      "cta": "Niveau du commutateur"
    },
    "layerNotVisibleAndObjectOnDifferentLevel": {
      "message": "L'objet cartographique sélectionné se trouve sur une couche visuellement masquée et à un niveau différent",
      "cta": "Basculer la visibilité et changer de niveau"
    }
  },
  "dates": {
    "objectDetails": {
      "noRangesAvailable": "Aucune fourchette",
      "rangeAvailable": "1 gamme",
      "rangesAvailable": "plages {{ rangesAmount }}",
      "add": "Ajouter des plages de dates et d'heures",
      "noDataAvailable": "Aucune donnée disponible"
    },
    "dateRangeAttribute": {
      "name": "Nom",
      "dates": "Dates",
      "time": "Heure"
    },
    "startDate": "Date de début",
    "attributeName": "Plage de dates et d'heures (par exemple, quarts de travail)",
    "attributeInfoBox": {
      "title": "Exemples de valeurs de données",
      "infoBlurb": "Utilisez cet attribut pour définir la plage de dates et d'heures auxquelles vous souhaitez que l'objet cartographique soit visible. Par exemple, « L'<strong>équipe matinale de John</strong> » sera affichée entre <strong>9 h 45 et 17 h</strong> <strong>45</strong>. Cette visibilité peut également être déterminée par la sélection dans la plage de dates et d'heures de la carte en bas à droite de la carte.",
      "johnsMorningShift": "Le quart de travail matinal de John"
    },
    "attributeSettings": "Paramètres des attributs",
    "addRange": "Ajouter une gamme",
    "mapObjectDateFiltered": "L'objet cartographique sélectionné est filtré en fonction de la date sélectionnée",
    "mapObjectDateFilteredCta": "Supprimer le filtre de date",
    "tooltip": {
      "title": "Plage de dates et d'heures récurrentes",
      "blurb": "Utilisez cette fonctionnalité pour définir des plages de répétition pour un événement spécifique sur des dates régulières. Par exemple, les quarts de travail des employés"
    },
    "calendarTooltip": "Filtre cartographique de date et d'heure"
  },
  "ranges": "gammes",
  "digitalTwin": {
    "loading": {
      "header": "Créez votre jumeau numérique",
      "message": "Cela peut prendre quelques instants"
    },
    "restarting": {
      "header": "Oups !",
      "message": "Désolé, quelque chose s'est mal passé. Nous allons vous reconnecter au jumeau numérique..."
    }
  },
  "styles": {
    "arrows": {
      "sameAsLine": "Identique à la ligne",
      "custom": "Personnalisé"
    },
    "customImage": "Image personnalisée",
    "customColour": "Couleur personnalisée",
    "selectImage": "Sélectionnez une image personnalisée",
    "customImagePerModel": "Vous ne pouvez télécharger qu'une seule image par modèle. Vous pouvez remplacer votre sélection ci-dessous.",
    "customImageAspectRatio": "Cette image n'a pas le format d'image spécifié pour {{ aspectRatio }} Il peut sembler étiré ou écrasé."
  },
  "moveLayer": {
    "front": "Mettre au premier plan",
    "back": "Envoyer vers retour"
  },
  "controls": {
    "user_location": "Localisation de l'utilisateur"
  },
  "deleteAttributePrompt": {
    "title": "Êtes-vous sûr de vouloir supprimer cet attribut ?",
    "message": "Cela supprimera définitivement les données attributaires de tous les objets de cette couche. Cette action n'est pas réversible."
  },
  "fileUpload": {
    "image_comment": "Téléchargez l'image pour commenter",
    "invalid": "Le fichier que vous avez chargé n'est pas valide. Veuillez télécharger un fichier .png, .jpg ou .jpeg valide"
  },
  "comments": {
    "edit": "Modifier le commentaire",
    "delete": "Supprimer le commentaire",
    "image": "Ajouter une image",
    "replaceImage": "Remplacer l'image"
  },
  "upload_asset": {
    "icon": "icône",
    "model": "modèle 3D",
    "upload_model": "Téléchargez un modèle 3D",
    "update_model": "Mettre à jour le modèle 3D",
    "upload_icon": "Télécharger une icône",
    "update_icon": "Icône Modifier",
    "name": "Nom de {{ assetType }}",
    "categories": "Catégories",
    "search_for_categories": "Rechercher des catégories",
    "select_asset": "Sélectionnez {{ assetType }}",
    "select_file": "Sélectionnez un fichier",
    "file_end": "Le fichier doit se terminer par",
    "or": "ou",
    "not_support_custom_image": "Le modèle que vous avez chargé ne prend pas en charge les images personnalisées. Pour savoir comment l'activer, consultez l'article ",
    "select_thumbnail": "Vignette",
    "something_went_wrong": "Quelque chose s'est mal passé",
    "image_size": "Taille de l'image",
    "image_style": "Style d'image",
    "image_file": "Fichier image",
    "enable_colour_customisation": "Activez la personnalisation des couleurs"
  },
  "permissionTooltip": "Vous n'êtes pas autorisé à ",
  "createLayerOptions": "Créer des options de couche",
  "cancelDrawing": "Annuler le dessin",
  "deleteObject": "Supprimer l'objet",
  "importNoWebSocketsToast": "L'importation/la copie des couches est terminée, actualisez-les pour voir les couches",
  "refresh": "Actualiser"
}